export default __webpack_public_path__ + "static/media/frog-nation-class.e6651d14.jpeg";